import i18n from "i18n";
const readableEntityType = (entityType, usages) => {
  switch (entityType) {
    case "SEARCH":
      return i18n.t("readable_filter_usages_summary.saved_search", { ns: "enterprise_search", count: usages });
    case "DASHBOARD_WIDGET":
      return i18n.t("readable_filter_usages_summary.dashboard_widget", { ns: "enterprise_search", count: usages });
    case "EVENT_DEFINITION":
      return i18n.t("readable_filter_usages_summary.event_definition", { ns: "enterprise_search", count: usages });
    default:
      return entityType;
  }
};
const readableFilterUsagesSummary = (summary) => summary.map(({ usages, type }) => `${usages} ${readableEntityType(type, usages)}`).join(", ");
export default readableFilterUsagesSummary;
